export default {
  PlayerHighlight: false,
  HubPages: true,
  MatchdayTakeover: false,
  TempSocialFeed: false,
  WhereToStream: false,
  PlayerProfileStats: false
}
